module.exports = __webpack_public_path__ + "static/media/dodgem(22).3e66db4e.PNG";